// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Constants
import { drawingStates } from 'constants/values';

// util
import { getStandardPolygonWinding } from 'geometry/geojson/winding';
import { getGeometry } from 'geometry/geojson/convert';

// Action Types
export const typePrefix = 'vra/current/uiwidgets/drawing/';
export const actions = [
  'SET_DRAWING_STATE',
  'SET_LAST_SHAPE_DRAWN'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer
export default function reducer(
  state = {
    drawingState: drawingStates.NONE
  },
  action = {}
) {
  switch (action.type) {
    case actions.SET_DRAWING_STATE:
      return {...state, drawingState: action.payload.drawingState };
    case actions.SET_LAST_SHAPE_DRAWN:
      return {...state, lastShapeDrawn: action.payload.shapeGeometry };

    default:
      return state;
  }
}

// Action Creators
export const setDrawingState = (drawingState) => {
  return {
    type: actions.SET_DRAWING_STATE,
    payload: { drawingState }
  };
};

/** @param shapeGeoJson Feature(XPolygon), XPolygon or null. Null clears the shape. */
export const setLastShapeDrawn = (shapeGeoJson) => {
  const shapeGeometry = (shapeGeoJson)
    ? getStandardPolygonWinding(getGeometry(shapeGeoJson)) // This normalizes the points to one winding order, regardless of what LeafletDraw sends.
    : null;
  return {
    type: actions.SET_LAST_SHAPE_DRAWN,
    payload: { shapeGeometry }
  };
};

export const clearLastShapeDrawn = () => setLastShapeDrawn(null);
